<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '46',
	},
	height: {
		type: String,
		default: '32',
	},
});
</script>
<template>
	<svg
		:width="width"
		:height="height"
		viewBox="0 0 58 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			fill="white"
		/>
		<rect
			x="0.5"
			y="0.5"
			width="57"
			height="39"
			rx="5.5"
			stroke="#F2F4F7"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M26.3972 32.1667H30.724C37.4781 32.1667 42.8602 26.8083 43.0713 20.1891V20.0841C42.9658 13.3599 37.4781 7.89642 30.724 8.00149H25.8696C19.4321 8.21162 14.3666 13.6751 14.5777 20.1891C14.5777 26.7032 19.8543 32.0616 26.3972 32.1667ZM16.6883 20.084C16.6883 14.6206 21.2262 10.1028 26.7138 10.1028C32.2015 10.1028 36.7394 14.6206 36.7394 20.084C36.7394 25.5475 32.2015 30.0653 26.7138 30.0653C21.2262 30.0653 16.6883 25.5475 16.6883 20.084ZM28.2968 26.8083V13.4649C31.9904 14.4105 34.3121 18.0878 33.3624 21.7651C32.7292 24.2867 30.8296 26.1779 28.2968 26.8083ZM20.1709 18.403C19.2211 22.0803 21.4372 25.8627 25.1309 26.8083V13.4649C22.7036 14.0953 20.804 15.9865 20.1709 18.403Z"
			fill="#0079BE"
		/>
	</svg>
</template>
